// components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  // const token = Cookies.get("token");
  const token = sessionStorage.getItem("token"); // Ganti 'token' dengan nama cookie kamu

  if (!token) {
    return <Navigate to="/sign-in" replace />;
  }

  return children;
};

export default ProtectedRoute;
